<p-toast position="top-right"></p-toast>

<merchant-create-store [_showMerchantCreateStoreSideBar]="showMerchantCreateStoreSideBar"
                       [partnerMartLocationsStoreDetailsComponent]="this"
                       (changedShowMerchantCreateStoreSideBarEmit)="changedShowMerchantCreateStoreSideBarEmit($event)"
                       *ngIf="showMerchantCreateStoreSideBar"
                       [editableStore]="storeData"></merchant-create-store>

<div class="partner-store-detail-body">
    <!--Body Header-->
    <partner-mart-locations-header [store]="store"></partner-mart-locations-header>

    <div class="sdl-block-main">
        <div *ngIf="loading" style="text-align: center; padding: 30px;">
            <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                               fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
        </div>

        <div *ngIf="!loading">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 290px)'}"
                           [styleClass]="'app-scrollpanel'">
                <div class="flex flex-row flex-wrap">
                    <div class="sdl-column">
                        <div class="sdl-title">
                            Location Details
                        </div>

                        <div class="sdl-field-block">
                            <div class="sdl-field-block__label">Street Address</div>
                            <div class="sdl-field-blockk__field">{{storeData.Address}}</div>
                        </div>

                        <div class="sdl-field-block">
                            <div class="sdl-field-block__label">Location Details</div>
                            <div class="flex flex-row">
                                <div class="sdl-field-column">
                                    <div class="sdl-field-blockk__field">{{storeData.Name}}</div>
                                </div>
                                <div class="sdl-field-column">
                                    <div class="sdl-field-blockk__field">{{storeData.LoacationTypeName}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="sdl-field-block">
                            <div class="sdl-field-blockk__field">{{storeData.AddressDetails}}</div>
                        </div>

                        <div class="sdl-field-block">
                            <div class="sdl-field-block__label">Store External Photos:</div>
                            <div class="flex flex-row">
                                <div class="store-upload-img-block">
                                    <img src="{{storeData.ImageUrl}}" class="store-upload-img" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="sdl-column">
                        <div id="map" style="height: 250px; border: 0.5px solid #0040604D; border-radius: 10px; margin-bottom: 18px; margin-top: 30px;"></div>

                        <div class="sdl-info-map">
                            Tip: You can manually move the pin for exact location. The Address will automatically update based upon pin location.
                        </div>
                    </div>
                </div>
            </p-scrollPanel>

            <div class="flex justify-content-end mrg-10-0px">
                <button class="bluedark-btn" pButton label="Edit" (click)="openMerchantCreateStoreSideBar()"></button>
            </div>
        </div>
    </div>
</div>
